import { authRoles } from "src/app/roles";
import Crud from "src/@bootstrap/components/Crud/Crud";
import NuovaCartella from "./NuovaCartella";
import CartellaDettaglio from "./CartellaDettaglio";

const cartelleRoutes = [
    {
        path: "cartelle/nuovo/:anagrafica",
        element: <NuovaCartella />,
        // auth: authRoles.admin
    },
    {
        path: "cartelle/ricerca",
        element: <Cartelle />,
        auth: authRoles.admin
    },
    {
        path: "cartelle/dettaglio/:id",
        element: <CartellaDettaglio />,
        // auth: authRoles.admin
    },
];

function Cartelle() {
    return <Crud module='cartelle' entity='cartelle' />;
};

export default cartelleRoutes;
